export var getHeadingNumber = function getHeadingNumber(sizesArray, size) {
  return (sizesArray.indexOf(size) + 1).toString();
};